import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import TopHeader from "../template/TopHeader";
import { connect, useDispatch, useSelector } from "react-redux";
import animationData from '../../assets/animation-data/loader.json'
import Lottie from 'react-lottie';
import { Addicon, Mail, Msz } from "../SvgIcon";
import MarketingTopNav from "./MarketingTopNav";
import AddCard from '../addCardPopup/addCard';
import { marketingAction } from "../../_actions/marketing.actions";
import toast from '../shared/Toast';
import ReviewBoosterPanel from './ReviewBoosterPanel';
import ReminderPanel from './ReminderPanel';
import BookingUpdatePanel from './BookingUpdatePanel';
import SalesPanel from './SalesPanel';
import CustomReminderPanel from './CustomReminderPanel';
import './MarketingList.css';
import CommunicationsHelp from './CommunicationsHelp';
import ClashCard from './ClashCard';
import { commsJobOf, journeyJob, JOB_WORDS } from './overlaps';
import { hydrateJourneys, saveJourney } from './journeys/journeysStore';
import { keepFrom } from './goUp';
import './communicationsSkin.css';


const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
  }
};

function Marketing(props) {
  const dispatch = useDispatch();
  const router = useHistory();
  const [marketingSetting, setMarketingSetting] = useState([]);
  const [helpOpen, setHelpOpen] = useState(false);
  const getSalonMarketingSetting = useSelector(state=>state?.getSalonMarketingSetting);
  const userInfo = useSelector(state=>state?.user?.userInfo);
  const [salonId, setSalonId] = useState(null);
  const [isLoader, setIsLoader] = useState(true);

  // Deep link from the Performance page's automations table: scroll to the
  // matching section once the page has data
  useEffect(() => {
    const section = props.location?.state?.openSection;
    if (!section || isLoader) return;
    const el = document.getElementById(section);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      props.history.replace('/marketing', keepFrom(props.location));
    }
  }, [isLoader]); // eslint-disable-line react-hooks/exhaustive-deps
  const[showmodal,setShowModal]=useState(false);
  const[salonData,setSalonData]=useState([]);
  const [panel, setPanel] = useState(null);

  const closePanel = () => setPanel(null);
  const handlePanelSaved = () => {
    setPanel(null);
    getSettings();
  };

  // No page-level scroll lock here: SlidePanel's shared lock already covers
  // <html>. A second lock here ran after SlidePanel's, saved its 'hidden' as
  // the value to restore, and left the page unscrollable after every save.

  const hideModal =()=>{
    setShowModal(false)
  }
  const showModal = ()=>{
    setShowModal(true)
  }
  useEffect(() => {
    // Add or remove class from body based on modal state
    if (showmodal) {
      document.body.classList.add('add_card_modal_open');
    } else {
      document.body.classList.remove('add_card_modal_open');
    }
  }, [showmodal]);
  useEffect(() => {
      const salonId = localStorage.getItem('salonId');
      setSalonId(salonId);
      getSettings();
      getMarketingSetting();

   /* eslint-disable-next-line */
  }, []);

  const getSettings = () => {
    dispatch(marketingAction.getSettings()).then((res) => {
      if (res.data.statusCode === 1) {
        if (res?.data?.responseData?.result!==undefined && res?.data?.responseData?.result!=null) {
          let data = res?.data?.responseData?.result;
          data.bookingUpdate = transformData("booking", data?.bookingUpdate);
          data.salesUpdate = transformData("sales", data?.salesUpdate);
          data.reviewBooster = transformData("reviewBooster", data?.reviewBooster);
          setMarketingSetting(data);
        }
        setIsLoader(false);
      }else{
        setIsLoader(false);
      }
    });
  };

  const transformData = (type, data) => {
    if (data.length < 1) {
      return [];
    }

    switch (type) {
      case "booking":
        const bookingCategoryData = [
          { id:1,
            title: "New booking",
            note: "Send client details when you book their appointment for them.",
          },
          { id:2,
            title: "Updated booking",
            note: "Send client details if you update their date, time or services.",
          },
          { id:3,
            title: "No-show",
            note: "Let your client know that they missed their appointment.",
          },
          { id:4,
            title: "Cancelled booking",
            note: "Let your client know that you cancelled their appointment.",
          },
          { id:5,
            title: "Thank you after visiting",
            note: "Thank your client for visiting and encourage a rebooking.",
          },
          { id:6,
            title: "Thank you for tipping",
            note: "Let your client know how much their tip means to you.",
          },
        ];
        return data.map((record, index) => {
          record.id = bookingCategoryData[index]?.id;
          record.title = bookingCategoryData[index]?.title;
          record.note = bookingCategoryData[index]?.note;
          return record;
        });

      case "sales":
        const salesCategoryData = [
          { id:1,
            title: "Reminder to rebook",
            note: "Remind your client to rebook a set time after their last booking.",
          },
          { id:2,
            title: "Happy birthday",
            note: "Send your clients a happy birthday message.",
          }
        ];

        return data.map((sales, index) => {
          sales.id = salesCategoryData[index]?.id;
          sales.title = salesCategoryData[index]?.title;
          sales.note = salesCategoryData[index]?.note;
          return sales;
        });

      case "reviewBooster":
        const reviewBoosterData = [
          { id:1,
            title: "Google Review Booster",
            note: "Send a link for Google reviews after every appointment.",
          },
        ];

        return data.map((rebooster, index) => {
          rebooster.id = reviewBoosterData[index]?.id;
          rebooster.title = reviewBoosterData[index]?.title;
          rebooster.note = reviewBoosterData[index]?.note;
          return rebooster;
        });

      default:
        return;
    }
  };

  // Switching on something a journey already does (a rebook reminder, a
  // birthday message, a thank-you, a no-show message): say so first, and
  // offer to pause the journey.
  const [clash, setClash] = useState(null);
  const requestStatus = (type, data, status) => {
    const job = status ? commsJobOf(type, data, marketingSetting) : null;
    if (!job) { updateStatus(type, data, status); return; }
    hydrateJourneys(localStorage.getItem('salonId')).then((list) => {
      const running = (list || []).filter((j) => j.status === 'ready' && journeyJob(j) === job);
      if (running.length) setClash({ type, data, running, job });
      else updateStatus(type, data, status);
    }).catch(() => updateStatus(type, data, status));
  };

  const updateStatus = (type, data, status) => {
    switch (type) {
      case "reminder":
        let reminderData = marketingSetting?.reminders?.map((reminder) => {
          if (reminder?._id === data?._id) {
            reminder.id = 1; //need to set dynamic value
            reminder.statusSMSreminder = status ? 1 : 0;
            reminder.statusEmailReminder = status ? 1 : 0;
            return reminder;
          }
          return reminder;
        });
        marketingSetting.reminders = reminderData;

        setMarketingSetting({ ...marketingSetting });
        updateSetting({ ...marketingSetting });
        break;

      case "booking":
        let bookingData = marketingSetting?.bookingUpdate?.map((booking) => {
          if (booking?._id === data?._id) {
            booking.statusSMSreminder = status ? 1 : 0;
            booking.statusEmailReminder = status ? 1 : 0;
            return booking;
          }
          return booking;
        });

        marketingSetting.bookingUpdate = bookingData;
        setMarketingSetting({ ...marketingSetting });
        updateSetting({ ...marketingSetting });
        break;

      case "sales":
        let salesData = marketingSetting?.salesUpdate?.map((sales) => {
          if (sales?._id === data?._id) {
            sales.statusSMSreminder = status ? 1 : 0;
            sales.statusEmailReminder = status ? 1 : 0;
            return sales;
          }
          return sales;
        });

        marketingSetting.salesUpdate = salesData;
        setMarketingSetting({ ...marketingSetting });
        updateSetting({ ...marketingSetting });
        break;

      case "custom":
        let customData = marketingSetting?.customUpdate?.map((custom) => {
          if (custom?._id === data?._id) {
            custom.statusSMSreminder = status ? 1 : 0;
            custom.statusEmailReminder = status ? 1 : 0;
            return custom;
          }
          return custom;
        });
        marketingSetting.customUpdate = customData;
        setMarketingSetting({ ...marketingSetting });
        updateSetting({ ...marketingSetting });
        break;

      case "reviewBooster":
        let reviewBooster = marketingSetting?.reviewBooster?.map((item) => {
          if (item?._id === data?._id) {
            item.statusSMSreminder = status ? 1 : 0;
            item.statusEmailReminder = status ? 1 : 0;
            return item;
          }
          return item;
        });

        marketingSetting.reviewBooster = reviewBooster;
        setMarketingSetting({ ...marketingSetting });
        updateSetting({ ...marketingSetting });
        break;

      default:
        return;
    }
  };

  const updateSetting = (data) => {
    data.type = 1;
    dispatch(marketingAction.updateSetting(data)).then((res) => {
      if (res.data.statusCode === 1) {
      }
    });
  };

  const goToUpdate =(type,data,index)=>{
    switch(type){
      case 'reminder':
        setPanel({
          type: 'reminder',
          data: { ...data, title: index === 0 ? 'Reminder' : 'Reminder ' + (index + 1) },
          index: index,
        });
        break;

      case 'updateBooking':
        setPanel({ type: 'booking', data });
        break;

       case 'sales':
        setPanel({ type: 'sales', data });
        break;

       case 'custom':
        setPanel({ type: 'custom', data });
        break;

      case 'reviewBooster':
        setPanel({ type: 'reviewBooster', data });
        break;

      default:
       break;
    }
  }


  const addReminder = (type) => {
    if(type==='reminder'){
      setPanel({ type: 'reminder', isCreate: true });
    }

    if(type==='custom'){
      setPanel({ type: 'custom', isCreate: true });
    }
 };

 useEffect(() => {
  setSalonData(getSalonMarketingSetting);
/* eslint-disable-next-line */
}, [getSalonMarketingSetting]);

 const getMarketingSetting = () => {
  dispatch(marketingAction.getMarketingSetting()).then((res) => {
    if (res.data.statusCode === 1) {
      if (res?.data?.responseData?.result.length>0) {
        let data = res?.data?.responseData?.result;
        dispatch(marketingAction.setSalonMarketingSetting(data));
        if(props.user&&props.user?.userInfo&&props.user?.userInfo?.hairdresser?.isSalonOwner===0) {
          if ((data[0].salonConsent === 1 && data[0].selfEmpConsent === 1)) {
            dispatch(marketingAction?.marketingSettingNavigation(false))
            router.push('/marketing-setting');
          }
        }
      }
      setIsLoader(false);
    }else{
      setIsLoader(false);
    }
  });
};


  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <AddCard />
        {panel?.type === 'reviewBooster' && (
          <ReviewBoosterPanel
            data={panel.data}
            salonId={salonId}
            onClose={closePanel}
            onSaved={handlePanelSaved}
          />
        )}
        {clash && (
          <ClashCard
            title="A journey does this too"
            text={`Your ${clash.running.map((j) => `“${j.name}”`).join(' and ')} ${clash.running.length === 1 ? 'journey already sends' : 'journeys already send'} ${JOB_WORDS[clash.job]}. With both on, clients get two.`}
            offLabel={clash.running.length === 1 ? 'Pause the journey' : 'Pause the journeys'}
            onKeep={() => { updateStatus(clash.type, clash.data, true); setClash(null); }}
            onDismiss={() => setClash(null)}
            onSwitchOff={async () => {
              const salonId = localStorage.getItem('salonId');
              clash.running.forEach((j) => saveJourney(salonId, { ...j, status: 'paused' }));
              updateStatus(clash.type, clash.data, true);
              setClash(null);
            }}
          />
        )}
        {panel?.type === 'reminder' && (
          <ReminderPanel
            data={panel.data}
            index={panel.index}
            isCreate={panel.isCreate}
            salonId={salonId}
            onClose={closePanel}
            onSaved={handlePanelSaved}
          />
        )}
        {panel?.type === 'booking' && (
          <BookingUpdatePanel
            data={panel.data}
            salonId={salonId}
            onClose={closePanel}
            onSaved={handlePanelSaved}
          />
        )}
        {panel?.type === 'sales' && (
          <SalesPanel
            data={panel.data}
            salonId={salonId}
            onClose={closePanel}
            onSaved={handlePanelSaved}
          />
        )}
        {panel?.type === 'custom' && (
          <CustomReminderPanel
            data={panel.data}
            isCreate={panel.isCreate}
            salonId={salonId}
            onClose={closePanel}
            onSaved={handlePanelSaved}
          />
        )}
        <div className="catalogue-page-wrapper">
          <MarketingTopNav activeTab="communications" />
          <div className="catalogue-content-container">
            <div className="container">
              <div className="row">
              {isLoader?
                <div className='col-12'>
                    <div className='salon-body-main-wrp booking-urlpage'>
                        <div className='new-stng-cmn'>
                        <div className="text-center pr-md-5">
                            <Lottie options={defaultOptions}
                                    height={50}
                                    width={200}
                            />
                            <h4 className="text-center">Loading Data...</h4>
                        </div>
                        </div>
                    </div>
                </div>:
              <div className="col-12">
              {marketingSetting?.length===0?
                <div className="salon-body-main-wrp account--password-temp new-stng-cmn __marketing " style={{height:"300px"}}>
                  <div className="_marketing_setting">
                     <h4 className="text-center mt-4">Marketing setting not available.</h4>
                  </div>
                </div>
                :
                <div className="salon-body-main-wrp account--password-temp new-stng-cmn __marketing mkt-v2">
                <div className='mkt-header'>
                  <div className='mkt-page-head'>
                    <div className='mkt-page-title-row'>
                      <h1 className='mkt-page-title'>Communications</h1>
                      <button type="button" className="pv2-help-btn" onClick={() => setHelpOpen(true)} aria-label="How communications work" title="How communications work">?</button>
                    </div>
                    <p className="mkt-intro">
                      Automated messages that minimise no-shows, drive rebooking and grow your reviews.
                    </p>
                  </div>
                  <div className='cmp-allowance' title='Free allowance renews on the 1st of the month'>
                    <div className='cmp-allowance-icon'>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                      </svg>
                    </div>
                    <div>
                      {/* Automated bucket — NOT the marketing pool. Falls back to the
                          legacy single-pot number pre-split. */}
                      <div className='cmp-allowance-num'>{marketingSetting.automatedRemaining ?? marketingSetting.remainingSms}</div>
                      <div className='cmp-allowance-label'>Automated SMS remaining</div>
                    </div>
                  </div>
                </div>
                {helpOpen && <CommunicationsHelp onClose={() => setHelpOpen(false)} />}
                  <div className="">
                    {/* <ul className="services_tab pl-0">
                      <li className="active">
                        <Link to="#_reminders">Reminders</Link>
                      </li>
                      <li className="">
                        <Link to="#_updates">Updates</Link>
                      </li>
                      <li className="">
                        <Link to="#_sales">Sales</Link>
                      </li>
                      <li className="">
                        <Link to="#_custom">Custom</Link>
                      </li>
                    </ul> */}
                    <div
                      className={`_service_parent_body _marketting_parent`}
                      // id="_service_parent_body"
                      // ref={this.scrollDivRef}
                      // onScroll={this.handleScroll}
                    >
                      <div
                        className="_service_parent _marketting_parent"
                        id="_custom"
                      >
                        <h3>Custom Automations</h3>
                        <div className="_markt_body ">
                          {marketingSetting?.customUpdate?.length > 0
                            ? marketingSetting?.customUpdate.map(
                                (custom, i) => (
                                  <div
                                    key={"booking" + custom?._id}
                                    className={"__markt"}
                                  >
                                  <div className="cursor-pointer" onClick={() =>
                                    goToUpdate('custom',custom,i)
                                 }>
                                    <h6 className="mt-3">{custom?.title?custom?.title:'Custom Reminder '+(i+1)} </h6>
                                    <p className="">{custom?.description
                                      ?custom?.description
                                      :null}</p>
                                   </div>
                                    <div className="_bottom">
                                      <div className="_left" onClick={() =>
                                        goToUpdate('custom',custom,i)
                                     }>
                                        {custom?.statusSMSreminder === 1 ? (
                                          <p className="mb-0 msz mr-2">
                                            <Msz />
                                          </p>
                                        ) : (
                                          <p className="mb-0 msz mr-2 disabled">
                                            <Msz />
                                          </p>
                                        )}
                                        {custom?.statusEmailReminder === 1 ? (
                                          <p className="mb-0 msz mr-2">
                                            <Mail />
                                          </p>
                                        ) : (
                                          <p className="mb-0 msz mr-2 disabled">
                                            <Mail />
                                          </p>
                                        )}
                                      </div>
                                      <div className="_right">
                                        <div className="salon_switch_container">
                                          <label
                                            className="switch"
                                            onChange={(e) =>
                                              requestStatus(
                                                "custom",
                                                custom,
                                                e?.target?.checked
                                              )
                                            }
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                custom?.statusSMSreminder ===
                                                  1 ||
                                                custom?.statusEmailReminder ===
                                                  1
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <span className="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                            : null}

                          <div className={"__markt _create_new"}>
                            <div className="_new cursor-pointer" onClick={()=>addReminder('custom')}>
                              <h6 className="mt-3">
                                <Addicon />
                              </h6>
                              <p className="">Create New Automation</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="_service_parent " id="_reminders">
                        <h3>Reminder</h3>
                        <div className="_markt_body ">
                          {marketingSetting?.reminders?.length > 0
                            ? marketingSetting?.reminders?.map(
                                (reminder, index) => (
                                  <div
                                    key={"reminder" + reminder?._id}
                                    className={"__markt"}
                                    >
                                    <div className="cursor-pointer" onClick={() =>
                                      goToUpdate('reminder',reminder,index)
                                   }>
                                    <h6 className="mt-3">
                                      Reminder {index + 1 > 1 ? index + 1 : ""}
                                    </h6>
                                    <p className="">
                                      {reminder?.reminderTime} {marketingAction?.reminderTimeType(reminder?.reminderTimeType
                                        )} before
                                      appointment
                                    </p>
                                    </div>
                                    <div className="_bottom">
                                      <div
                                        className="_left"
                                        onClick={() =>
                                            goToUpdate('reminder',reminder,index)
                                        }
                                      >
                                        {reminder?.statusSMSreminder === 1 ? (
                                          <p className="mb-0 msz mr-2">
                                            <Msz />
                                          </p>
                                        ) : (
                                          <p className="mb-0 msz mr-2 disabled">
                                            <Msz />
                                          </p>
                                        )}
                                        {reminder?.statusEmailReminder === 1 ? (
                                          <p className="mb-0 msz mr-2">
                                            <Mail />
                                          </p>
                                        ) : (
                                          <p className="mb-0 msz mr-2 disabled">
                                            <Mail />
                                          </p>
                                        )}
                                      </div>
                                      <div className="_right">
                                        <div className="salon_switch_container">
                                          <label className="switch">
                                            <input
                                              type="checkbox"
                                              onChange={(e) =>
                                                requestStatus(
                                                  "reminder",
                                                  reminder,
                                                  e?.target?.checked
                                                )
                                              }
                                              checked={
                                                reminder?.statusSMSreminder ===
                                                  1 ||
                                                reminder?.statusEmailReminder ===
                                                  1
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <span className="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                            : null}
                          <div className={"__markt _create_new"}>
                            <div className="_new" >
                              <h6
                                className="mt-3 cursor-pointer"
                                onClick={() => addReminder('reminder')}
                               >
                                <Addicon />
                              </h6>
                              <p className="_create_new">Create New Reminder</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          className="_service_parent _marketting_parent"
                          id="_reviewbooster"
                      >
                        <h3>Review Booster</h3>
                        <div className="_markt_body ">
                          {marketingSetting?.reviewBooster?.length > 0
                              ? marketingSetting?.reviewBooster.map((sales, i) => (
                                  <div
                                      key={"booking" + sales?._id}
                                      className={"__markt"}
                                  >
                                    <div className="cursor-pointer" onClick={() =>
                                        goToUpdate('reviewBooster',sales,i)
                                    }>
                                      <h6 className="mt-3">{sales?.title} </h6>
                                      <p className=""> {sales?.note}</p>
                                    </div>
                                    <div className="_bottom">
                                      <div className="_left"  onClick={() =>
                                          goToUpdate('reviewBooster',sales)
                                      }>
                                        {sales?.statusSMSreminder === 1 ? (
                                            <p className="mb-0 msz mr-2">
                                              <Msz />
                                            </p>
                                        ) : (
                                            <p className="mb-0 msz mr-2 disabled">
                                              <Msz />
                                            </p>
                                        )}
                                        {sales?.statusEmailReminder === 1 ? (
                                            <p className="mb-0 msz mr-2">
                                              <Mail />
                                            </p>
                                        ) : (
                                            <p className="mb-0 msz mr-2 disabled">
                                              <Mail />
                                            </p>
                                        )}
                                      </div>
                                      <div className="_right">
                                        <div className="salon_switch_container">
                                          <label
                                              className="switch"
                                              onChange={(e) =>
                                                  requestStatus(
                                                      "reviewBooster",
                                                      sales,
                                                      e?.target?.checked
                                                  )
                                              }
                                          >
                                            <input
                                                type="checkbox"
                                                checked={
                                                  sales?.statusSMSreminder === 1 ||
                                                  sales?.statusEmailReminder === 1
                                                      ? true
                                                      : false
                                                }
                                            />
                                            <span className="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              ))
                              : null}
                        </div>
                      </div>
                      <div
                        className="_service_parent _marketting_parent _update"
                        id="_updates"
                      >
                        <h3>Updates</h3>
                        <div className="_markt_body ">
                          {marketingSetting?.bookingUpdate?.length > 0
                            ? marketingSetting?.bookingUpdate.map(
                                (booking, i) => (
                                  <div
                                    key={"booking" + booking?._id}
                                    className={"__markt"}
                                  >
                                  <div className="cursor-pointer" onClick={() =>
                                    goToUpdate('updateBooking',booking,i)
                                 }>
                                    <h6 className="mt-3">{booking?.title} </h6>
                                    <p className="">{booking?.note}</p>
                                    </div>
                                    <div className="_bottom">
                                      <div className="_left"  onClick={() =>
                                        goToUpdate('updateBooking',booking,i)
                                    }>
                                        {booking?.statusSMSreminder === 1 ? (
                                          <p className="mb-0 msz mr-2">
                                            <Msz />
                                          </p>
                                        ) : (
                                          <p className="mb-0 msz mr-2 disabled">
                                            <Msz />
                                          </p>
                                        )}
                                        {booking?.statusEmailReminder === 1 ? (
                                          <p className="mb-0 msz mr-2">
                                            <Mail />
                                          </p>
                                        ) : (
                                          <p className="mb-0 msz mr-2 disabled">
                                            <Mail />
                                          </p>
                                        )}
                                      </div>
                                      <div className="_right">
                                        <div className="salon_switch_container">
                                          <label
                                            className="switch"
                                            onChange={(e) =>
                                              requestStatus(
                                                "booking",
                                                booking,
                                                e?.target?.checked
                                              )
                                            }
                                          >
                                            <input
                                              type="checkbox"
                                              checked={
                                                booking?.statusSMSreminder ===
                                                  1 ||
                                                booking?.statusEmailReminder ===
                                                  1
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <span className="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                            : null}
                        </div>
                      </div>

                      <div
                        className="_service_parent _marketting_parent"
                        id="_sales"
                      >
                        <h3>Sales</h3>
                        <div className="_markt_body ">
                          {marketingSetting?.salesUpdate?.length > 0
                            ? marketingSetting?.salesUpdate.map((sales, i) => (
                                <div
                                  key={"booking" + sales?._id}
                                  className={"__markt"}
                                >
                                <div className="cursor-pointer" onClick={() =>
                                  goToUpdate('sales',sales,i)
                               }>
                                  <h6 className="mt-3">{sales?.title} </h6>
                                  {sales?.type===1?<p className="">{sales?.reminderTime} {marketingAction?.reminderTimeType(sales?.reminderTimeType
                                    )} after last booking {sales?.note}</p>:<p className=""> {sales?.note}</p>}
                                  </div>
                                  <div className="_bottom">
                                    <div className="_left"  onClick={() =>
                                      goToUpdate('sales',sales)
                                  }>
                                      {sales?.statusSMSreminder === 1 ? (
                                        <p className="mb-0 msz mr-2">
                                          <Msz />
                                        </p>
                                      ) : (
                                        <p className="mb-0 msz mr-2 disabled">
                                          <Msz />
                                        </p>
                                      )}
                                      {sales?.statusEmailReminder === 1 ? (
                                        <p className="mb-0 msz mr-2">
                                          <Mail />
                                        </p>
                                      ) : (
                                        <p className="mb-0 msz mr-2 disabled">
                                          <Mail />
                                        </p>
                                      )}
                                    </div>
                                    <div className="_right">
                                      <div className="salon_switch_container">
                                        <label
                                          className="switch"
                                          onChange={(e) =>
                                            requestStatus(
                                              "sales",
                                              sales,
                                              e?.target?.checked
                                            )
                                          }
                                        >
                                          <input
                                            type="checkbox"
                                            checked={
                                              sales?.statusSMSreminder === 1 ||
                                              sales?.statusEmailReminder === 1
                                                ? true
                                                : false
                                            }
                                          />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : null}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>}
              </div>}
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(Marketing);
